module.exports = __webpack_public_path__ + "static/media/map-pin.6ce115d8.svg";